import type { RouteLocationNormalizedLoaded, Router } from 'vue-router'

/** 从路由读取账单关联的委托单上下文（新建页 query 传入） */
export function getBillRouteContext(route: RouteLocationNormalizedLoaded) {
  const consignmentNo = (route.query.consignmentNo as string | undefined)?.trim() || undefined
  const orderIdRaw = route.query.orderId
  let orderId: number | undefined
  if (orderIdRaw != null && orderIdRaw !== '') {
    const parsed = Number(orderIdRaw)
    if (Number.isFinite(parsed)) orderId = parsed
  }
  return { consignmentNo, orderId }
}

/** 保存/查询可用费用时附带 orderId、consignmentNo */
export function withBillRouteContext(
  payload: Record<string, unknown>,
  route: RouteLocationNormalizedLoaded
) {
  const { consignmentNo, orderId } = getBillRouteContext(route)
  return {
    ...payload,
    ...(consignmentNo ? { consignmentNo } : {}),
    ...(orderId != null ? { orderId } : {})
  }
}

/** 保存后导航：有 billId 则进详情页，否则从委托单进入则返回 */
export function navigateAfterBillSave(
  router: Router,
  route: RouteLocationNormalizedLoaded,
  options: {
    isCreate: boolean
    billType: 'payable' | 'receivable'
    saved?: { billId?: string | number } | null
  }
) {
  if (!options.isCreate) return
  const { consignmentNo, orderId } = getBillRouteContext(route)
  // 从运输委托单进入：通过 sessionStorage 通知委托单页面切到账单页签，然后返回
  if (consignmentNo || orderId != null) {
    sessionStorage.setItem('tcActiveTab', 'billing')
    router.back()
    return
  }
  // 从结算对账等入口进入：跳转到新建账单的详情页
  const savedId = options.saved?.billId
  if (savedId != null && String(savedId)) {
    router.replace({ path: `/billing/${options.billType}/${savedId}` })
    return
  }
  router.back()
}
